import apiClient from './Api';

const PREFIX = '/theme';

export const getThemeColors = postData => {
  return apiClient({
    url: `${PREFIX}/getThemeColors`,
    method: 'POST',
    data: postData
  });
};
export const saveThemeColors = postData => {
  return apiClient({
    url: `${PREFIX}/saveThemeColors`,
    method: 'POST',
    data: postData
  });
};
